/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProcessedJoinRequest
 */
export interface ProcessedJoinRequest {
    /**
     * 
     * @type {string}
     * @memberof ProcessedJoinRequest
     */
    auth_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProcessedJoinRequest
     */
    approved: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProcessedJoinRequest
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProcessedJoinRequest
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessedJoinRequest
     */
    group_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcessedJoinRequest
     */
    role?: string | null;
}

/**
 * Check if a given object implements the ProcessedJoinRequest interface.
 */
export function instanceOfProcessedJoinRequest(value: object): value is ProcessedJoinRequest {
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('approved' in value) || value['approved'] === undefined) return false;
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function ProcessedJoinRequestFromJSON(json: any): ProcessedJoinRequest {
    return ProcessedJoinRequestFromJSONTyped(json, false);
}

export function ProcessedJoinRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessedJoinRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_id': json['auth_id'],
        'approved': json['approved'],
        'success': json['success'],
        'message': json['message'],
        'group_name': json['group_name'] == null ? undefined : json['group_name'],
        'role': json['role'] == null ? undefined : json['role'],
    };
}

export function ProcessedJoinRequestToJSON(json: any): ProcessedJoinRequest {
    return ProcessedJoinRequestToJSONTyped(json, false);
}

export function ProcessedJoinRequestToJSONTyped(value?: ProcessedJoinRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_id': value['auth_id'],
        'approved': value['approved'],
        'success': value['success'],
        'message': value['message'],
        'group_name': value['group_name'],
        'role': value['role'],
    };
}

